import { useEffect, useState } from "react";
import { FlaskConical, Bell, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";

const parts = (at) => {
  const ms = new Date(at) - Date.now();
  if (ms <= 0) return null;
  const d = Math.floor(ms / 86400000), h = Math.floor((ms % 86400000) / 3600000), m = Math.floor((ms % 3600000) / 60000);
  return `${d}d ${h}h ${String(m).padStart(2, "0")}m`;
};

export const useLaunch = () => {
  const [l, setL] = useState(null);
  useEffect(() => { api.get("/auth/launch").then((r) => setL(r.data)).catch(() => {}); }, []);
  return l;
};

export const WaitlistForm = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.post("/waitlist", { email }); setDone(data.already ? "You're already on the list — we'll email you the moment registration opens." : "You're on the list. We'll email you the moment registration opens."); }
    catch { setDone("That didn't go through — please check the email address."); }
    finally { setBusy(false); }
  };
  if (done) return <div className="waitlist-done" data-testid="waitlist-done"><CheckCircle2 size={16} /> {done}</div>;
  return (
    <form className="waitlist" onSubmit={submit} data-testid="waitlist-form">
      <input type="email" required placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="waitlist-email-input" />
      <button className="btn" disabled={busy} data-testid="waitlist-submit-btn"><Bell size={14} /> {busy ? "…" : "Notify me at launch"}</button>
    </form>
  );
};

export const BetaHero = () => {
  const l = useLaunch();
  const [left, setLeft] = useState(null);
  useEffect(() => { if (!l) return; const tick = () => { const ms = new Date(l.launch_at) - Date.now(); setLeft(ms > 0 ? { d: Math.floor(ms / 86400000), h: Math.floor((ms % 86400000) / 3600000), m: Math.floor((ms % 3600000) / 60000) } : null); }; tick(); const t = setInterval(tick, 30000); return () => clearInterval(t); }, [l]);
  if (!l || l.open) return null;
  return (
    <section className="beta-hero" data-testid="beta-hero">
      <div className="beta-hero-k"><FlaskConical size={14} /> PRIVATE BETA</div>
      <h2 className="beta-hero-h">ExperTraQ is not live yet.</h2>
      <p className="beta-hero-p">We are testing with invited traders right now. Public registration opens</p>
      <div className="beta-hero-date" data-testid="beta-hero-date">{l.label}</div>
      {left && <div className="beta-hero-count" data-testid="beta-hero-countdown">
        {[["d", "days"], ["h", "hours"], ["m", "minutes"]].map(([k, lab]) => <div key={k}><b className="mono">{String(left[k]).padStart(2, "0")}</b><span>{lab}</span></div>)}
      </div>}
      <p className="beta-hero-p" style={{ marginTop: 18 }}>Invited testers can sign in below. Everyone else: the calculators, charts and market news are free to use today.</p>
      <WaitlistForm />
    </section>
  );
};

export const BetaBanner = ({ compact }) => {
  const l = useLaunch();
  const [left, setLeft] = useState(null);
  useEffect(() => { if (!l) return; setLeft(parts(l.launch_at)); const t = setInterval(() => setLeft(parts(l.launch_at)), 30000); return () => clearInterval(t); }, [l]);
  if (!l || l.open) return null;
  if (compact) return <span className="beta-chip" data-testid="beta-chip"><FlaskConical size={11} /> Beta · registration opens {l.label}</span>;
  return (
    <div className="beta-banner" data-testid="beta-banner">
      <FlaskConical size={16} />
      <span><b>Beta testing in progress.</b> ExperTraQ is being trialled by invited testers. Public registration opens <b>{l.label}</b>{left && <> · <span className="mono" data-testid="beta-countdown">{left}</span></>}</span>
    </div>
  );
};
